var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient_color",class:{ gradient_color__active: _vm.active },style:({ backgroundImage: _vm.gradientColor })})}
var staticRenderFns = []

export { render, staticRenderFns }